interface Props {
    addNodeResMsg: string | string[];
}
const Badge = ({ addNodeResMsg }: Props) => {
    let permissionArray: string[] = [];
    let error: any;
    let data: any[] = [];

    if (typeof addNodeResMsg === 'string') {
        permissionArray = addNodeResMsg.split(':');
        if (permissionArray[permissionArray.length - 1].includes(',')) {
            const dataSet = permissionArray.pop();
            data = dataSet !== undefined ? dataSet.split(',') : [];
        }
    } else {
        addNodeResMsg.map((res) => (error = res.split(':')));
        data = error[1].split(',');
    }

    return (
        <div className='mt-3'>
            {!error ? (
                permissionArray.map((d, idx) => (
                    <p className={`mb-0 text-dark ${data.length ? '' : 'text-center'}`} key={d.toString()}>
                        {permissionArray[idx]}:
                    </p>
                ))
            ) : (
                <span className='text-dark'>{error[0]}:</span>
            )}
            {data.map((d, idx) => (
                <span className='badge bg-white text-primary m-1 border' key={d.toString()}>
                    {data[idx]}
                </span>
            ))}
        </div>
    );
};

export default Badge;
